// pages/TarifaSupervision/utils/validateMonthYear.js
import dayjs from "dayjs";

/**
 * La UI envía MES DE VENCIMIENTO (mes/año) y el PERIODO también es ese mes.
 * - Duplicado: valida contra el MISMO mes/año seleccionados.
 * - Continuidad: valida que exista el mes anterior (con ajuste de año).
 * - Bloquea mes actual y meses futuros (comparando contra el mes seleccionado).
 */
export async function validateMonthYearPure({
  mes,
  anio,
  servicio,
  usuarioSitae,
  getExisteAvisoDelMes,
  getValidarAvisosMes,
  getValidarAporteMes,
  now = dayjs(),
}) {
  const currentMonth = now.month() + 1;
  const currentYear = now.year();

  const selMes = Number(mes);
  const selAnio = Number(anio);

  // 0) Mes seleccionado no puede ser actual ni futuro
  if (selAnio > currentYear || (selAnio === currentYear && selMes > currentMonth)) {
    return {
      isAporteDisabled: false,
      mustUncheckAporte: false,
      isGuardarDisabled: true,
      errorMessage: "No puede seleccionar un mes a futuro.",
      alreadyExists: false,
    };
  }
  if (selAnio === currentYear && selMes === currentMonth) {
    return {
      isAporteDisabled: false,
      mustUncheckAporte: false,
      isGuardarDisabled: true,
      errorMessage: "No puede seleccionar el mes y año actual.",
      alreadyExists: false,
    };
  }

  // 1) Mes anterior con AJUSTE DE AÑO (enero -> dic del año anterior)
  const prev = selMes === 1 ? { m: 12, y: selAnio - 1 } : { m: selMes - 1, y: selAnio };

  // 2) Consultas en paralelo
  const [dupRes, avisoPrevRes, aportePrevRes] = await Promise.all([
    // ¿ya existe aviso para ESTE mismo mes seleccionado?
    getExisteAvisoDelMes(usuarioSitae, selMes, selAnio, servicio),
    // ¿existe aviso del mes anterior (con rollover de año)?
    getValidarAvisosMes(usuarioSitae, prev.m, prev.y, servicio),
    // ¿existe aporte del mes anterior?
    getValidarAporteMes(usuarioSitae, prev.m, prev.y, servicio),
  ]);

  const alreadyExists = (dupRes?.[0]?.MesIngresado ?? 0) > 0;
  const avisoPrevOK = (avisoPrevRes?.[0]?.MesIngresado ?? 0) !== 0;
  const aportePrevOK = (aportePrevRes?.[0]?.MesIngresado ?? 0) !== 0;

  if (alreadyExists) {
    return {
      isAporteDisabled: !aportePrevOK,
      mustUncheckAporte: !aportePrevOK,
      isGuardarDisabled: true,
      errorMessage: "Ya existe un aviso para el mes seleccionado.",
      alreadyExists: true,
    };
  }
  if (!avisoPrevOK) {
    return {
      isAporteDisabled: !aportePrevOK,
      mustUncheckAporte: !aportePrevOK,
      isGuardarDisabled: true,
      errorMessage: "Debe facturar el aviso del mes anterior antes de continuar.",
      alreadyExists: false,
    };
  }

  return {
    isAporteDisabled: !aportePrevOK,
    mustUncheckAporte: !aportePrevOK,
    isGuardarDisabled: false,
    errorMessage: null,
    alreadyExists: false,
  };
}

/** Wrapper igual al que ya tienes */
export function makeValidateMonthYearWrapper(ctx) {
  return async (mes, anio, servicio) => {
    const r = await validateMonthYearPure({
      mes,
      anio,
      servicio,
      usuarioSitae: ctx.usuarioSitae,
      getExisteAvisoDelMes: ctx.getExisteAvisoDelMes,
      getValidarAvisosMes: ctx.getValidarAvisosMes,
      getValidarAporteMes: ctx.getValidarAporteMes,
    });
    ctx.setIsAporteDisabled(Boolean(r.isAporteDisabled));
    if (r.mustUncheckAporte) ctx.setMostrarAporte(false);
    ctx.setIsGuardarDisabled(Boolean(r.isGuardarDisabled));
    return r.errorMessage;
  };
}
